import React from 'react';
import { useFormContext } from 'react-hook-form';
import { LenderMappingsFormValues } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';
import { CurrencyInputField, InputField, NumberFormatField } from 'components/form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';

interface Props {
  field: LenderFieldMap;
  inputProps: any;
  formatter?: (value: string) => string;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const TextMappingField = ({ field, inputProps, formatter, onValueChange }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<LenderMappingsFormValues>();

  const type = field.details?.fieldInputType;
  const isRequired = field.details?.required === 'REQUIRED';

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (field.lenderProperty) {
      onValueChange(field.lenderProperty, e.target.value);
    }
  };

  if (type === 'FLOAT' || type === 'INTEGER') {
    return (
      <NumberFormatField
        label={field.details?.displayName!}
        control={control}
        name={`mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`}
        rules={{
          required: isRequired,
        }}
        textFieldProps={{
          required: isRequired,
          variant: 'outlined',
          size: 'small',
          onBlur: handleBlur,
          inputProps: {
            ...(inputProps.min && { min: inputProps.min }),
            ...(inputProps.max && { max: inputProps.max }),
          },
        }}
      />
    );
  }

  if (type === 'MONEY') {
    return (
      <CurrencyInputField
        label={field.details?.displayName!}
        control={control}
        name={`mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`}
        rules={{
          required: isRequired,
        }}
        textFieldProps={{
          required: isRequired,
          variant: 'outlined',
          onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            const value = e.target.value.replace(/[^0-9.-]+/g, '');
            onValueChange(field.lenderProperty!, value);
          },
          inputProps: {
            ...(inputProps.min && { min: inputProps.min }),
            ...(inputProps.max && { max: inputProps.max }),
          },
        }}
      />
    );
  }

  return (
    <InputField
      label={field.details?.displayName!}
      control={control}
      name={`mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`}
      rules={{ required: isRequired }}
      inputProps={{
        required: isRequired,
        error: !!errors.mappingsByLenderFieldId?.[field.lenderFieldId!]?.mappedValue,
        variant: 'outlined',
        onBlur: handleBlur,
        ...(inputProps.min && { min: inputProps.min }),
        ...(inputProps.max && { max: inputProps.max }),
      }}
      formatter={formatter}
    />
  );
};
